



// import React, { useEffect, useState } from "react";
// import "../../Template/LayoutMain/LayoutMain/Layout.css";
// import "./Bookings.css";
// import UpcommingBookingsTable from "./UpcommingBookingsTable/UpcommingBookingsTable";
// import PreviousBookingsTable from "./PreviousBookingsTable/PreviousBookingsTable";
// import ChatTab from "./ChatTab/ChatTab";


// const Bookings = () => {
//   const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
//     const stored = sessionStorage.getItem("isSidebarOpen");
//     return stored !== null ? JSON.parse(stored) : true;
//   });

//  const [activeTab, setActiveTab] = useState(() => {
//   const savedTab = sessionStorage.getItem("bookingsActiveTab");
//   return savedTab ? savedTab : "upcomming";
// });

// useEffect(() => {
//   sessionStorage.setItem("bookingsActiveTab", activeTab);
// }, [activeTab]);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       const stored = sessionStorage.getItem("isSidebarOpen");
//       const parsed = stored !== null ? JSON.parse(stored) : true;

//       if (parsed !== isSidebarOpen) {
//         setIsSidebarOpen(parsed);
//       }
//     }, 10);

//     return () => clearInterval(interval);
//   }, [isSidebarOpen]);

//   return (
// <div
//   className={`content-container ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"}`}
//   style={{ marginTop: "100px" }}
// >
//   <div className="page-inner-wrapper">

//     <h2 className="page-title">Shoot Bookings</h2>

//     {/* Tabs */}
//   <div className="custom-tabs">
//   <div
//     className={`tab-item ${activeTab === "upcomming" ? "active" : ""}`}
//     onClick={() => setActiveTab("upcomming")}
//   >
//     Upcoming Bookings
//   </div>

//   <div
//     className={`tab-item ${activeTab === "chat" ? "active" : ""}`}
//     onClick={() => setActiveTab("chat")}
//   >
//     Chat
//   </div>

//   <div
//     className={`tab-item ${activeTab === "previous" ? "active" : ""}`}
//     onClick={() => setActiveTab("previous")}
//   >
//     Booking History
//   </div>


// </div>


//     {/* Table */}
//   {activeTab === "upcomming" && <UpcommingBookingsTable />}
// {activeTab === "previous" && <PreviousBookingsTable />}
// {activeTab === "chat" && <ChatTab />}


//   </div>
// </div>

//   );
// };

// export default Bookings;




import React, { useEffect, useState } from "react";
import "../../Template/LayoutMain/LayoutMain/Layout.css";
import "./Bookings.css";

import UpcommingBookingsTable from "./UpcommingBookingsTable/UpcommingBookingsTable";
import PreviousBookingsTable from "./PreviousBookingsTable/PreviousBookingsTable";
import HourlyBookingsPage from "./UpcomingHourlyComponent/UpcomingHourlyPage/UpcomingHourlyPage";
import UpcomingEditingPage from "./UpcomingEditingComponent/UpcomingEditingPage/UpcomingEditingPage";
import PreviousHourlyPage from "./PreviousHourlyBookingTable/PreviousHourlyPage";
import PreviousEditingPage from "./PreviousHourlyBookingTable/PreviousEditingPage";
import ChatTab from "./ChatTab/ChatTab";



const Bookings = () => {

  /* ---------- Sidebar ---------- */

  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    const stored = sessionStorage.getItem("isSidebarOpen");
    return stored !== null ? JSON.parse(stored) : true;
  });

  /* ---------- Main Tab ---------- */

  const [activeTab, setActiveTab] = useState(() => {
    return sessionStorage.getItem("bookingsActiveTab") || "upcomming";
  });

  /* ---------- Sub Tabs (Separate for each main tab) ---------- */

  const [subTabs, setSubTabs] = useState(() => {

    const saved = sessionStorage.getItem("bookingsSubTabs");

    return saved
      ? JSON.parse(saved)
      : {
        upcomming: "customize",
        previous: "customize",
      };

  });

  /* Current SubTab */
  const currentSubTab =
    activeTab === "previous"
      ? subTabs.previous
      : subTabs.upcomming;

  /* Save Main Tab */

  useEffect(() => {
    sessionStorage.setItem("bookingsActiveTab", activeTab);
  }, [activeTab]);

  /* Save Sub Tabs */

  useEffect(() => {
    sessionStorage.setItem(
      "bookingsSubTabs",
      JSON.stringify(subTabs)
    );
  }, [subTabs]);

  /* Sidebar Sync */

  useEffect(() => {

    const interval = setInterval(() => {

      const stored = sessionStorage.getItem("isSidebarOpen");
      const parsed =
        stored !== null ? JSON.parse(stored) : true;

      if (parsed !== isSidebarOpen) {
        setIsSidebarOpen(parsed);
      }

    }, 10);

    return () => clearInterval(interval);

  }, [isSidebarOpen]);

  /* SubTab Change Handler */

  const handleSubTabChange = (tab) => {

    if (activeTab === "previous") {

      setSubTabs({
        ...subTabs,
        previous: tab,
      });

    } else {

      setSubTabs({
        ...subTabs,
        upcomming: tab,
      });

    }

  };

  return (

    <div
      className={`content-container ${isSidebarOpen
        ? "sidebar-open"
        : "sidebar-closed"
        }`}
      style={{ marginTop: "100px" }}
    >

      <div className="page-inner-wrapper">

        <h2 className="page-title">
          Shoot Bookings
        </h2>

        {/* ---------- MAIN TABS ---------- */}

        <div className="custom-tabs">

          <div
            className={`tab-item ${activeTab === "upcomming"
              ? "active"
              : ""
              }`}
            onClick={() =>
              setActiveTab("upcomming")
            }
          >
            Upcoming Bookings
          </div>

          <div
            className={`tab-item ${activeTab === "chat"
              ? "active"
              : ""
              }`}
            onClick={() =>
              setActiveTab("chat")
            }
          >
            Chat
          </div>

          <div
            className={`tab-item ${activeTab === "previous"
              ? "active"
              : ""
              }`}
            onClick={() =>
              setActiveTab("previous")
            }
          >
            Booking History
          </div>

        </div>

        {/* ---------- SUB TABS ---------- */}

        {(activeTab === "upcomming" ||
          activeTab === "previous") && (

            <div className="custom-tabs sub-tabs">

              <div
                className={`tab-item ${currentSubTab === "customize"
                  ? "active"
                  : ""
                  }`}
                onClick={() =>
                  handleSubTabChange("customize")
                }
              >
                Customize Booking
              </div>

              <div
                className={`tab-item ${currentSubTab === "hourly"
                  ? "active"
                  : ""
                  }`}
                onClick={() =>
                  handleSubTabChange("hourly")
                }
              >
                Hourly Booking
              </div>

              <div
                className={`tab-item ${currentSubTab === "editing"
                  ? "active"
                  : ""
                  }`}
                onClick={() =>
                  handleSubTabChange("editing")
                }
              >
                Editing Booking
              </div>

            </div>

          )}

        {/* ---------- TABLES ---------- */}

        {/* UPCOMING */}

        {activeTab === "upcomming" &&
          currentSubTab === "customize" && (
            <UpcommingBookingsTable />
          )}

        {activeTab === "upcomming" && currentSubTab === "hourly" && (
          <HourlyBookingsPage />
        )}

        {activeTab === "upcomming" && currentSubTab === "editing" && (
          <UpcomingEditingPage />
        )}

        {/* PREVIOUS */}

        {activeTab === "previous" &&
          currentSubTab === "customize" && (
            <PreviousBookingsTable />
          )}

        {activeTab === "previous" && currentSubTab === "hourly" && (
          <PreviousHourlyPage />
        )}

        {activeTab === "previous" && currentSubTab === "editing" && (
          <PreviousEditingPage />
        )}

        {/* CHAT */}

        {activeTab === "chat" && (
          <ChatTab />
        )}

      </div>

    </div>

  );

};

export default Bookings;